import { useActaDetalleStore } from "../../store/actaDetalleStore";
import { useGeneralAppStore } from "../../store/generalAppStore";
import ModalActaAuditar from "./ModalActaAuditar";
import ModalActaDetalle from "./ModalActaDetalle";
import ModalActaDetalle2 from "./ModalActaDetalle2";
import ModalAlertas from "./ModalAlertas";
import ModalAprobadaImprimir from "./ModalAprobadaImprimir";
import ModalBajaTribunal from "./ModalBajaTribunal";
import ModalCompletarDatos from "./ModalCompletarDatos";
import ModalConfirm from "./ModalConfirm";
import ModalConstancia from "./ModalConstancia";
import ModalConstanciaAnular from "./ModalConstanciaAnular";
import ModalDesasignar from "./ModalDesasignar";
import ModalDescargo from "./ModalDescargo";
import ModalDictamen from "./ModalDictamen";
import ModalEditarActa from "./ModalEditarActa";
import ModalGenerarActa from "./ModalGenerarActa";
import ModalGenerarPago from "./ModalGenerarPago";
import ModalImpresaActa from "./ModalImpresaActa";
import ModalIncompletaActa from "./ModalIncompletaActa";
import ModalMarcarImpresa from "./ModalMarcarImpresa";
import ModalNotificadores from "./ModalNotificadores";
import ModalNotificarActa from "./ModalNotificarActa";
import ModalNotificarDigital from "./ModalNotificarDigital";
import ModalPago from "./ModalPago";
import ModalReasignar from "./ModalReasignar";
import ModalRecibo from "./ModalRecibo";

const ModalsOpcionesActas = ({ setRefetch }) => {
  //? ESTADOS GLOBALES
  const { modals, handlerModal } = useGeneralAppStore();
  const { actaDetalle } = useActaDetalleStore();

  return (
    <>


      {modals.includes("alertas_acta") && (
        <ModalAlertas modals={modals} handlerModal={handlerModal} />
      )}
      {modals.includes("notificadores") && (
        <ModalNotificadores modals={modals} handlerModal={handlerModal} setRefetch={setRefetch} />
      )}
      {modals.includes("impresa_acta_detalle") && (
        <ModalImpresaActa modals={modals} handlerModal={handlerModal} setRefetch={setRefetch} />
      )}
      {modals.includes("incompleta_acta_detalle") && (
        <ModalIncompletaActa modals={modals} handlerModal={handlerModal} setRefetch={setRefetch} />
      )}
      {modals.includes("aprobada_imprimir") && (
        <ModalAprobadaImprimir modals={modals} handlerModal={handlerModal} setRefetch={setRefetch} />
      )}
      {modals.includes("descargo") && <ModalDescargo modals={modals} handlerModal={handlerModal} setRefetch={setRefetch} />}
      {modals.includes("modal_dictaminar_acta") && <ModalDictamen modals={modals} handlerModal={handlerModal} setRefetch={setRefetch} />}
      {modals.includes("modal_generar_pago") && <ModalGenerarPago modals={modals} handlerModal={handlerModal} setRefetch={setRefetch} />}
      {modals.includes("constancia") && (
        <ModalConstancia modals={modals} handlerModal={handlerModal} />
      )}
      {modals.includes("generar_acta") && (
        <ModalGenerarActa modals={modals} handlerModal={handlerModal} />
      )}
      {modals.includes("desasignar_notificador") && (
        <ModalDesasignar modals={modals} handlerModal={handlerModal} setRefetch={setRefetch} />
      )}
      {modals.includes("reasignar_notificador") && (
        <ModalReasignar modals={modals} handlerModal={handlerModal} setRefetch={setRefetch} />
      )}
      {modals.includes("editar_acta") && (
        <ModalEditarActa modals={modals} handlerModal={handlerModal} setRefetch={setRefetch} />
      )}

      {modals.includes("modal_confirm") && (
        <ModalConfirm titleModal={"Confirmar"} titleMensaje={"Anular Acta"} variant={"danger"} setRefetch={setRefetch} />
      )}
      {modals.includes("modal_notificar_digital") && (
        <ModalNotificarDigital titleModal={"Confirmar"} titleMensaje={"Notificar Acta Digital"} variant={"success"} />
      )}
      {modals.includes("modal_notificar_acta") && (
        <ModalNotificarActa titleModal={"Confirmar"} titleMensaje={"Notificar Acta"} variant={"success"} />
      )}
      {modals.includes("modal_recibo") && (
        <ModalRecibo titleModal={"Obtener último recibo generado"} />
      )}
      {modals.includes("auditar_acta") && <ModalActaAuditar titleModal={"Logs"} />}
      {/* {modals.includes("modal_notificar") && (<ModalNotificar titleModal={"Notificar infracción"} />)} */}

      {modals.includes("completar_datos") && (
        <ModalCompletarDatos
          setRefetch={setRefetch}
          modals={modals}
          handlerModal={handlerModal}
          actaDetalle={actaDetalle}
        />
      )}

      {modals.includes("acta_detalle") && <ModalActaDetalle2 setRefetch={setRefetch} fullscreen />}
      {/* {modals.includes("acta_detalle") && <ModalActaDetalle modals={modals} hande />} */}
      {modals.includes("marcar_impresa") && <ModalMarcarImpresa type={"table"} />}

      {modals.includes("baja_tribunal") && <ModalBajaTribunal titleModal={"Confirmar baja tribunal"} setRefetch={setRefetch} />}


      {modals.includes("constancia_anulacion") && <ModalConstanciaAnular titleModal={"Constancia de anulación"} setRefetch={setRefetch} />}

      {/* {modals.includes("aprobada_imprimir") && (
        <ModalAprobadaImprimir modals={modals} handlerModal={handlerModal} />
      )} */}
      {modals.includes("modal_pago_dictamen") && (
        <ModalPago modals={modals} handlerModal={handlerModal} setRefetch={setRefetch} />
      )}
    </>
  );
};
export default ModalsOpcionesActas;
